<template>
    <div>
        <h3 class="text-xl sm:text-2xl xl:text-3xl mb-6">Renew your domain</h3>

        <div class="flex flex-wrap">
            <div class="w-full pb-8 md:w-2/3 md:pr-4">

                <sau-dynamic-table :data="renewableDomains" :loaded="ready" :collapse="true">
                    <template #table-header>
                        <tr>
                            <th>Domain</th>
                            <th>Expires</th>
                            <th>Registration Period</th>
                            <th>Add</th>
                        </tr>
                    </template>

                    <template v-slot="{ item }">
                        <tr>
                            <td>{{ item.domain }}</td>
                            <td><span class="d-inline-block d-sm-none">Expires: </span>{{ item.expiry }}</td>
                            <td>
                                <select @change="updateRegistrationPeriod(item)" v-model="item.registration_period">
                                    <option
                                        v-for="period in item.price"
                                        :value="period.registration_period"
                                        :key="period.domain">{{ period.display }} - {{ period.rrp | currency }} (Ex. GST)
                                    </option>
                                </select>
                            </td>
                            <td @click="actionDomain(item)">
                                <i class="fas fa-cart-plus text-xl" :class="{ 'text-grey' : ! item.selected, 'text-success' : item.selected }"></i>
                            </td>

                        </tr>
                    </template>


                    <template #table-loading>
                        <sau-spinner class="border py-5">
                            <template slot="message">Finding domains to renew</template>
                        </sau-spinner>
                    </template>

                    <template #table-empty>
                        <sau-apiro-response type="message">
                            <template slot="message">None of your domains are up for renewal at the moment.</template>
                        </sau-apiro-response>
                    </template>

                </sau-dynamic-table>

            </div>

            <sau-ordering-sidebar :data="data" :order="order"></sau-ordering-sidebar>
        </div>

    </div>
</template>

<script>

    import SauTable from "../utilities/SauTable";

    export default {

        props: {
            data: Object,
            order: Object,
        },

        components: {
            'sau-dynamic-table': SauTable,
        },

        inject: ['addOrderItemPromise', 'updateItemPromise', 'removeItemPromise'],

        data() {
            return {
                type: 'domain-renewal',
                domains: [],
                priceList: null,
                ready: false,
            }
        },

        mounted() {
            this.priceList = this.data.config.domain.domainrenew;
            this.getRenewableDomains();
        },

        methods: {
            getRenewableDomains() {
                this.getRequest('/api/domains/renewable')
                    .then(response => {
                        this.domains = response.data.map(expiring => {

                            return {...expiring, ...{
                                selected: this.isDomainInOrder(expiring.domain),
                                extension: this.getDomainExtension(expiring.domain),
                                price: this.getDomainPricing(expiring.domain),
                                registration_period: this.getDomainPricing(expiring.domain)[0].registration_period
                            }};
                        })
                    })
                    .finally(() => this.ready = true);
            },


            addRenewDomain(domainToAdd) {
                domainToAdd.selected = true;

                const itemData = {
                    domain: domainToAdd.domain,
                    registration_period: domainToAdd.registration_period,
                };

                this.addOrderItemPromise(this.type, itemData)
                    .then(response => this.updateItemPromise(this.type, response.slug, itemData));

            },


            removeRenewDomain(domainToRemove) {
                const itemToRemove = this.order.items.find(item => item.type === this.type && item.domain === domainToRemove.domain);
                if(! itemToRemove ) return;

                domainToRemove.selected = false;
                this.removeItemPromise(itemToRemove);
            },


            updateRegistrationPeriod(domainToUpdate) {
                const orderItem = this.fetchDomainFromOrder(domainToUpdate.domain);
                if(! orderItem) return;

                const itemData = {
                    domain: domainToUpdate.domain,
                    registration_period: domainToUpdate.registration_period,
                };

                this.updateItemPromise(this.type, orderItem.slug, itemData);
            },

            isDomainInOrder(domain) {
                return !! this.order.items.find(item => item.type === this.type && item.domain === domain);
            },

            getDomainExtension(domain) {
                return `.${domain.split('.').slice(1).join('.')}`;
            },

            getDomainPricing(domain) {
                const extension = this.getDomainExtension(domain);
                const domainPricing = this.priceList.find(extPricing => extPricing.extension === extension);

                return domainPricing.pricing;
            },

            actionDomain(domain) {
                domain.selected ? this.removeRenewDomain(domain) : this.addRenewDomain(domain);
            },

            fetchDomainFromOrder(domain) {
                return this.order.items.find(item => item.type === this.type && item.domain === domain);
            },

        },

        computed: {
            renewableDomains() {
                if(! this.domains) return [];
                return this.domains.map(item => {
                    item.selected = this.isDomainInOrder(item.domain);
                    return item;
                })
            }
        }
    }
</script>
